import { StyleSheet } from "react-native"

export default StyleSheet.create({
  questionListWithSubQuestions: {
    flex: 1,
  },
})
